export default "__VITE_ASSET__gzl2OAvS__"